/* import {  } from '@/scripts/constants/test'; */
// import store from '@/scripts/store';

const getBlobContent = (blob = {}) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(blob);

    reader.addEventListener('load', () => {
      resolve(reader.result);
    });

    reader.addEventListener('error', error => reject(error));
  });

const getFormData = file => {
  const formData = new FormData();
  const name = Math.random() * 10e16;

  formData.append('file', file, name);

  return formData;
};

/*  */
export { getBlobContent, getFormData };
